import React, {  useState } from "react";
import { PictureOutlined } from "@ant-design/icons";
import { Modal, Progress, Upload } from "antd";
import {  updateExpert } from "../../../service/api";
import { useMutation,  useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import DocumentShowModal from "./modals/documnetShowModal/DocumentShowModal";
import { toast } from "react-toastify";

const DocumentsUpload = ({ data }) => {
  const queryClient = useQueryClient()
  const [previewImage, setPreviewImage] = useState("")
  const [previewTitle, setPreviewTitle] = useState("")
  const [previewOpen, setPreviewOpen] = useState(false)
  const [privateLinkShow, setPrivateLinkShow] = useState([false, null])


  const [nationalCardUploadProgress, setNationalCardUploadProgress] = useState(0);
  const [studentCardUploadProgress, setStudentCardUploadProgress] = useState(0);
  const [academicDegreeDocumentUploadProgress, setAcademicDegreeDocumentUploadProgress] = useState(0);
  const [engineeringSystemCardUploadProgress, setEngineeringSystemCardUploadProgress] = useState(0);

  // nationalCard
  const [nationalCardFileList, setNationalCardFileList] = useState([]);

  // studentCard
  const [studentCardFileList, setStudentCardFileList] = useState([]);

  // academicDegreeDocument
  const [academicDegreeDocumentFileList, setAcademicDegreeDocumentFileList] =
    useState([]);

  // engineeringSystemCard
  const [engineeringSystemCardFileList, setEngineeringSystemCardFileList] =
    useState([]);

  const mutation = useMutation(updateExpert, {
    onSuccess: () => {
      queryClient.invalidateQueries(["expertData"]);
    },
  });

  const customRequest = async (options, fileType) => {
    const { file, onSuccess, onError, onProgress } = options;

    const isLt5M = (file.size / (1024 * 1024)) * 10 <= 5;
    if (!isLt5M) {
      onError(toast.error("حجم فایل باید کمتر از   5 مگابایت باشد"));
      return;
    }

    try {
      // send file name to get upload info
      const response = await axios.post(
        process.env.REACT_APP_EXPERT_BASE_URL + "/files/s3-upload-file",
        { filename: file?.name }
      );
      // destructure upload info
      const { url, fields } = response?.data?.result?.data;
      const { key } = fields; // key is in fields
      // create formdata
      let formData = new FormData();
      Object.entries(fields).map(([key, value]) => {
        return formData.append(key, value);
      });
      formData.append("file", file);

      // progress tracking config
      const config = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          if (fileType === "national-card") {
            setNationalCardUploadProgress(percentCompleted); // Update the upload progress
          }
          if (fileType === "student-card") {
            setStudentCardUploadProgress(percentCompleted); // Update the upload progress
          }
          if (fileType === "academic-degree-document") {
            setAcademicDegreeDocumentUploadProgress(percentCompleted); // Update the upload progress
          }
          if (fileType === "engineering-system-card") {
            setEngineeringSystemCardUploadProgress(percentCompleted); // Update the upload progress
          }
          onProgress({ percent: percentCompleted }, file); // Notify Ant Design of the progress
        },
      };

      // upload formdata to Arvan cloud
      const arvanResponse = await axios.post(url, formData, config);
      // add originFileObj and key to file
      file.originFileObj = file;
      file.key = key;

      if (fileType === "national-card") {
        setNationalCardFileList([...nationalCardFileList, file]);
        mutation.mutate({ identityDocument: key });
      }
      if (fileType === "student-card") {
        setStudentCardFileList([...studentCardFileList, file]);
        mutation.mutate({ studentCard: key });
      }
      if (fileType === "academic-degree-document") {
        setAcademicDegreeDocumentFileList([
          ...academicDegreeDocumentFileList,
          file,
        ]);
        mutation.mutate({
          academicDegreeDocument: key,
        });
      }
      if (fileType === "engineering-system-card") {
        setEngineeringSystemCardFileList([
          ...engineeringSystemCardFileList,
          file,
        ]);
        mutation.mutate({
          engineeringSystemCard: key,
        });
      }
      // call onSuccess
      onSuccess(arvanResponse?.data);
    } catch (error) {
      onError(error);
    }
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name);
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  return (
    <div className="bg-white rounded-2xl p-6 flex flex-col gap-2 ">
      <h2 className="text-right font-body text-2xl font-bold text-[#005AC7] max-lg:text-[0.875rem]">
        مدارک تحصیلی و هویتی
      </h2>
      <section className="flex flex-row font-body justify-evenly max-lg:flex-col max-lg:m-auto">
        <div className="   max-lg:w-full  justify-end items-center flex">
          <div className="flex flex-row gap-4  w-[320px] items-center">
            <label className="font-body  w-full ">کارت ملی</label>
            <div className="  items-center justify-center w-fit">
            
                <Upload
                  listType="picture-card"
                  fileList={nationalCardFileList}
                  onPreview={handlePreview}
                  customRequest={(options) =>
                    customRequest(options, "national-card")
                  }
                  accept=".png, .jpg, .jpeg"
                  maxCount={1}
                >
                  {nationalCardFileList.length >= 1 ? null : (
                    <PictureOutlined className="text-7xl text-[#7F7F7F] " />
                  )}
                </Upload>
              
            </div>
            {nationalCardUploadProgress > 0 && nationalCardUploadProgress < 100 && (
              <Progress
                className="z-50"
                percent={nationalCardUploadProgress}
                status="active"
              />
            )}
            {data?.identityDocument && (
              <p
                className="text-xs text-blue-500 cursor-pointer w-0"
                onClick={() => {
                  setPrivateLinkShow([true, data?.identityDocument]);
                }}
              >
                مشاهده
              </p>
            )}
            {previewOpen && (
              <Modal
                open={previewOpen}
                title={previewTitle}
                footer={null}
                onCancel={() => setPreviewOpen(false)}
              >
                <img
                  alt="example"
                  style={{ width: "100%" }}
                  src={previewImage}
                />
              </Modal>
            )}
          </div>
        </div>

        <div className="   max-lg:w-full  justify-end items-center flex">
          <div className="flex flex-row gap-4  w-[320px] items-center">
            <label className="font-body  w-full  ">آخرین مدرک تحصیلی</label>
            <div className="  items-center justify-center w-fit">
            
                <Upload
                  listType="picture-card"
                  fileList={academicDegreeDocumentFileList}
                  onPreview={handlePreview}
                  customRequest={(options) =>
                    customRequest(options, "academic-degree-document")
                  }
                  accept=".png, .jpg, .jpeg"
                  maxCount={1}
                >
                  {academicDegreeDocumentFileList.length >= 1 ? null : (
                    <PictureOutlined className="text-7xl text-[#7F7F7F] " />
                  )}
                </Upload>
            
            </div>
            {academicDegreeDocumentUploadProgress > 0 && academicDegreeDocumentUploadProgress < 100 && (
              <Progress
                className="z-50"
                percent={academicDegreeDocumentUploadProgress}
                status="active"
              />
            )}
            {data?.academicDegreeDocument && (
              <p
                className="text-xs  text-blue-500 cursor-pointer  w-0"
                onClick={() => {
                  setPrivateLinkShow([true, data?.academicDegreeDocument]);
                }}
              >
                مشاهده
              </p>
            )}
            {previewOpen && (
              <Modal
                open={previewOpen}
                title={previewTitle}
                footer={null}
                onCancel={() => setPreviewOpen(false)}
              >
                <img
                  alt="example"
                  style={{ width: "100%" }}
                  src={previewImage}
                />
              </Modal>
            )}
          </div>
        </div>
      </section>
      <section className="flex flex-row font-body justify-evenly max-lg:flex-col max-lg:m-auto">
        <div className="   max-lg:w-full  justify-end items-center flex">
          <div className="flex flex-row gap-4  w-[320px] items-center ">
            <label className="font-body  w-full ">کارت دانشجویی</label>
            <div className="  items-center justify-center w-fit">
            
                <Upload
                  listType="picture-card"
                  fileList={studentCardFileList}
                  onPreview={handlePreview}
                  customRequest={(options) =>
                    customRequest(options, "student-card")
                  }
                  accept=".png, .jpg, .jpeg"
                  maxCount={1}
                >
                  {studentCardFileList.length >= 1 ? null : (
                    <PictureOutlined className="text-7xl text-[#7F7F7F] " />
                  )}
                </Upload>
             
            </div>
            {studentCardUploadProgress > 0 && studentCardUploadProgress < 100 && (
              <Progress
                className="z-50"
                percent={studentCardUploadProgress}
                status="active"
              />
            )}
            {data?.studentCard && (
              <p
                className="text-xs  text-blue-500 cursor-pointer w-0 font-body"
                onClick={() => {
                  setPrivateLinkShow([true, data?.studentCard]);
                }}
              >
                مشاهده
              </p>
            )}
            {previewOpen && (
              <Modal
                open={previewOpen}
                title={previewTitle}
                footer={null}
                onCancel={() => setPreviewOpen(false)}
              >
                <img
                  alt="example"
                  style={{ width: "100%" }}
                  src={previewImage}
                />
              </Modal>
            )}
          </div>
        </div>
        <div className="   max-lg:w-full  justify-end items-center flex ">
          <div className="flex flex-row gap-4  w-[320px] items-center ">
            <label className="font-body  w-full  ">کارت نظام مهندسی</label>
            <div className="  items-center justify-center w-fit">
            
                <Upload
                  listType="picture-card"
                  fileList={engineeringSystemCardFileList}
                  onPreview={handlePreview}
                  customRequest={(options) =>
                    customRequest(options, "engineering-system-card")
                  }
                  accept=".png, .jpg, .jpeg"
                  maxCount={1}
                >
                  {engineeringSystemCardFileList.length >= 1 ? null : (
                    <PictureOutlined className="text-7xl text-[#7F7F7F] " />
                  )}
                </Upload>
             
            </div>
            {engineeringSystemCardUploadProgress > 0 && engineeringSystemCardUploadProgress < 100 && (
              <Progress
                className="z-50"
                percent={engineeringSystemCardUploadProgress}
                status="active"
              />
            )}
            {data?.engineeringSystemCard && (
              <p
                className="text-xs  text-blue-500 cursor-pointer font-body w-0"
                onClick={() => {
                  setPrivateLinkShow([true, data?.engineeringSystemCard]);
                }}
              >
                مشاهده
              </p>
            )}
            {previewOpen && (
              <Modal
                open={previewOpen}
                title={previewTitle}
                footer={null}
                onCancel={() => setPreviewOpen(false)}
              >
                <img
                  alt="example"
                  style={{ width: "100%" }}
                  src={previewImage}
                />
              </Modal>
            )}
          </div>
        </div>
      </section>
      {privateLinkShow[0] && <DocumentShowModal privateLinkShow={privateLinkShow} setPrivateLinkShow={setPrivateLinkShow}/>}
    </div>
  );
};

export default DocumentsUpload;
